export default {
  // Page title
  'page.title': 'Timer',

  // Popular timers
  'popular.title': 'Timer Populer',
  'popular.10s': 'Timer 10 Detik',
  'popular.20s': 'Timer 20 Detik',
  'popular.30s': 'Timer 30 Detik',
  'popular.40s': 'Timer 40 Detik',
  'popular.50s': 'Timer 50 Detik',
  'popular.90s': 'Timer 1,5 Menit',
  'popular.2minute': 'Timer 2 Menit',
  'popular.3minute': 'Timer 3 Menit',
  'popular.5minute': 'Timer 5 Menit',
  'popular.10minute': 'Timer 10 Menit',
  'popular.15minute': 'Timer 15 Menit',
  'popular.30minute': 'Timer 30 Menit',
  'popular.60minute': 'Timer 60 Menit',
  'popular.1hour': 'Timer 1 Jam',
  'popular.10hour': 'Timer 10 Jam',
  'popular.24hour': 'Timer 24 Jam',
  'popular.48hour': 'Timer 48 Jam',

  // How to use
  'howto.title': 'Cara Mengatur Timer',
  'howto.titleMinutes': 'Cara Mengatur Timer {{minutes}} Menit',
  'howto.titleSeconds': 'Cara Mengatur Timer {{seconds}} Detik',
  'howto.titleHour': 'Cara Mengatur Timer {{hours}} Jam',
  'howto.titleHours': 'Cara Mengatur Timer {{hours}} Jam',
  'howto.step1': '⚙️ Atur Waktu Anda: Klik angka jam atau menit untuk mengedit waktu secara langsung. Anda dapat mengatur hingga 23 jam dan 59 menit untuk tugas apa pun.',
  'howto.step2': '⚡ Penyesuaian Waktu Cepat: Gunakan tombol tambah cepat yang nyaman untuk langsung menambahkan 30 detik, 1 menit, 5 menit, 10 menit, atau 30 menit ke timer Anda.',
  'howto.step3': '▶️ Mulai & Kontrol: Klik "Mulai" untuk memulai hitung mundur. Anda dapat menjeda kapan saja untuk istirahat dan melanjutkan saat siap, atau mengatur ulang untuk memulai dari awal.',
  'howto.step4': '🔔 Dapatkan Notifikasi: Terima notifikasi desktop dan peringatan suara yang dapat disesuaikan saat waktu habis. Aktifkan/nonaktifkan suara di sudut kanan atas.',
  'howto.step5': '🖥️ Mode Layar Penuh: Klik tombol layar penuh untuk pengaturan waktu tanpa gangguan - sempurna untuk presentasi, meditasi, atau sesi kerja yang fokus.',
  'howto.step6': '📱 Berfungsi Di Mana Saja: Gunakan di perangkat apa pun - desktop, tablet, atau ponsel. Tidak perlu unduhan, berfungsi langsung di browser Anda.',

  // User review submission
  'reviewSubmission.title': 'Bagikan Pengalaman Anda',
  'reviewSubmission.subtitle': 'Bantu orang lain menemukan timer ini dengan membagikan pengalaman Anda',
  'reviewSubmission.ratingLabel': 'Nilai pengalaman Anda',
  'reviewSubmission.commentLabel': 'Ulasan Anda (opsional)',
  'reviewSubmission.commentPlaceholder': 'Ceritakan bagaimana timer ini membantu Anda dengan produktivitas, memasak, belajar, atau aktivitas lainnya...',
  'reviewSubmission.nameLabel': 'Nama Anda (opsional)',
  'reviewSubmission.namePlaceholder': 'Bagaimana kami harus menampilkan nama Anda?',
  'reviewSubmission.submitButton': 'Kirim Ulasan',
  'reviewSubmission.thankYou': 'Terima kasih atas ulasan Anda!',
  'reviewSubmission.thankYouMessage': 'Masukan Anda membantu kami berkembang dan membantu orang lain menemukan timer kami.',
  'reviewSubmission.error': 'Silakan pilih penilaian sebelum mengirim.',

  // User reviews
  'reviews.title': 'Apa Kata Pengguna Kami',
  'reviews.newReview': 'Ulasan Baru',
  'reviews.mikeZhang': 'Pengubah permainan untuk produktivitas saya! Teknik Pomodoro dengan timer ini membantu saya menyelesaikan tesis. Antarmuka bersih, tanpa gangguan.',
  'reviews.lisaLee': 'Sempurna untuk waktu dapur! Tidak akan pernah memasak telur terlalu matang lagi. Peringatan suaranya cukup keras tapi tidak mengganggu. Ibu saya yang sudah tua juga menyukainya.',
  'reviews.johnDeveloper': 'Timer istirahat coding terbaik! Tombol preset menghemat banyak waktu. Membantu mencegah ketegangan mata dan membuat saya tetap fokus selama sprint.',
  'reviews.msChen': 'Mengubah manajemen kelas saya! Siswa benar-benar menikmati aktivitas berwaktu sekarang. Hitung mundur visual membuat semua orang tetap terlibat.',
  'reviews.fitnessPro': 'Revolusioner untuk latihan HIIT! Waktu yang akurat, kontrol mudah bahkan dengan tangan berkeringat. Klien saya menyukai mode layar penuh.',
  'reviews.sarahMarketer': 'Meningkatkan efisiensi rapat saya sebesar 40%! Tidak ada lagi diskusi yang tidak ada habisnya. Batas waktu memaksa keputusan dan membuat semua orang tetap fokus.',
  'reviews.tomChef': 'Penting di dapur restoran saya! Pasta, steak, saus - waktu yang sempurna setiap saat. Tombol tambah cepat yang beragam sangat jenius.',
  'reviews.amyStudent': 'Pengubah permainan belajar! Memutus siklus menunda-nunda dengan potongan waktu yang dapat dikelola. Dari nilai C ke A menggunakan metode ini.',
  'reviews.davidWriter': 'Menyembuhkan writer\'s block saya! Sprint menulis 15 menit menciptakan momentum. Menerbitkan 3 artikel bulan ini berkat timer ini.',
  'reviews.rachelTherapist': 'Sempurna untuk sesi meditasi dengan klien. Peringatan lembut tidak merusak suasana damai. Sangat profesional.',
  // Preset timer specific reviews
  'reviews.managerZhang': 'Penting untuk pekerjaan kantor! Sempurna untuk menyeduh teh dan istirahat rapat, antarmuka bersih tidak akan mengganggu pekerjaan.',
  'reviews.mrsLi': 'Timer telur yang sempurna! Telur rebus 3 menit menjadi sempurna setiap kali, peringatan suara sangat bijaksana, tidak ada telur yang terlalu matang.',
  'reviews.programmerWang': 'Penting untuk latihan mata saat istirahat coding, 3 menit pas untuk mengendurkan otot mata, bagus untuk perlindungan penglihatan!',

  // Use cases
  'useCases.title': 'Kasus Penggunaan Timer {{minutes}} Menit',
  'useCases.titleSeconds': 'Kasus Penggunaan Timer {{seconds}} Detik',
  'useCases.titleHours': 'Kasus Penggunaan Timer {{hours}} Jam',

  // Page titles
  'pageTitle': 'Timer {{minutes}} Menit',
  'pageTitleSeconds': 'Timer {{seconds}} Detik',
  'pageTitleHour': 'Timer {{hours}} Jam',
  'pageTitleHours': 'Timer {{hours}} Jam',

  // User names
  'user.mikeZhang': 'Mike Zhang',
  'user.lisaLee': 'Lisa Lee',
  'user.johnDeveloper': 'John Developer',
  'user.msChen': 'Ms. Chen',
  'user.fitnessPro': 'Fitness Pro',
  'user.sarahMarketer': 'Sarah Marketer',
  'user.tomChef': 'Tom Chef',
  'user.amyStudent': 'Amy Student',
  'user.davidWriter': 'David Writer',
  'user.rachelTherapist': 'Rachel Therapist',
  // Preset timer specific users
  'user.managerZhang': 'Manager Zhang',
  'user.mrsLi': 'Mrs. Li',
  'user.programmerWang': 'Programmer Wang',

  // Use cases
  'useCases.quickBreak.title': 'Istirahat Cepat',
  'useCases.quickBreak.desc': 'Istirahat singkat antara sesi kerja untuk menyegarkan pikiran dan mencegah kelelahan',
  'useCases.eyeCare.title': 'Pengingat Perawatan Mata',
  'useCases.eyeCare.desc': 'Ikuti aturan 20-20-20: setiap 20 menit, lihat sesuatu sejauh 20 kaki selama 20 detik',
  'useCases.teaBrewing.title': 'Menyeduh Teh',
  'useCases.teaBrewing.desc': 'Waktu penyeduhan sempurna untuk teh hijau (3 menit), teh hitam (5 menit), atau campuran herbal',
  'useCases.lightExercise.title': 'Olahraga Ringan',
  'useCases.lightExercise.desc': 'Peregangan kantor, yoga meja, atau olahraga sederhana untuk melawan gaya hidup tidak aktif',
  'useCases.meditation.title': 'Mindfulness & Meditasi',
  'useCases.meditation.desc': 'Latihan pernapasan terpandu, praktik kesadaran, atau meditasi penghilang stres',
  'useCases.softBoiledEggs.title': 'Timer Memasak',
  'useCases.softBoiledEggs.desc': 'Waktu sempurna untuk telur rebus (5 menit), memasak pasta, atau tugas dapur apa pun',
  'useCases.quickReading.title': 'Membaca Fokus',
  'useCases.quickReading.desc': 'Sesi membaca terkonsentrasi untuk buku, artikel, atau materi belajar',
  'useCases.phoneCall.title': 'Timer Panggilan & Rapat',
  'useCases.phoneCall.desc': 'Jaga panggilan telepon tetap pada jalur, batasi durasi rapat, atau atur waktu presentasi',
  'useCases.focusedWork.title': 'Sesi Kerja Pomodoro',
  'useCases.focusedWork.desc': 'Teknik Pomodoro klasik - 25 menit kerja fokus diikuti dengan istirahat',
  'useCases.exercise.title': 'Latihan & Pelatihan',
  'useCases.exercise.desc': 'Interval intensitas tinggi, latihan sirkuit, atau durasi olahraga spesifik',
  // 15-minute specific
  'useCases.shortMeeting.title': 'Rapat Singkat',
  'useCases.shortMeeting.desc': 'Pembaruan tim cepat, standup harian, atau diskusi kolaboratif singkat',
  'useCases.powerNap.title': 'Power Nap',
  'useCases.powerNap.desc': 'Durasi tidur siang optimal untuk dorongan energi tanpa rasa mengantuk',
  'useCases.learning.title': 'Sesi Belajar',
  'useCases.learning.desc': 'Latihan bahasa, tutorial keterampilan, atau segmen video pendidikan',
  'useCases.creativity.title': 'Sprint Kreatif',
  'useCases.creativity.desc': 'Sesi brainstorming, sprint menulis, atau latihan artistik',
  // 30-minute specific
  'useCases.deepWork.title': 'Sesi Kerja Mendalam',
  'useCases.deepWork.desc': 'Kerja fokus yang diperpanjang dengan gangguan minimal untuk tugas-tugas kompleks',
  'useCases.workout.title': 'Latihan Lengkap',
  'useCases.workout.desc': 'Rutinitas olahraga penuh, sesi yoga, atau program pelatihan terstruktur',
  'useCases.study.title': 'Blok Belajar',
  'useCases.study.desc': 'Sesi belajar intensif untuk ujian, penelitian, atau pengembangan keterampilan',
  'useCases.presentation.title': 'Latihan Presentasi',
  'useCases.presentation.desc': 'Latihan pidato, latihan pitch, atau waktu penyampaian presentasi',

  // Timer-specific user reviews
  // 1-minute timer users
  'user.officeWorkerAlex': 'Alex Office',
  'user.developerSarah': 'Sarah Dev',
  'user.designerMike': 'Mike Design',
  'reviews.officeWorkerAlex': 'Sempurna untuk istirahat cepat antara rapat! Hanya 1 menit untuk meregangkan badan dan refokus membuat perbedaan besar.',
  'reviews.developerSarah': 'Bagus untuk aturan 20-20-20 - setiap 20 menit saya melihat sesuatu sejauh 20 kaki selama 1 menit. Mata saya terasa jauh lebih baik!',
  'reviews.designerMike': 'Saya menggunakan ini untuk istirahat mikro selama pekerjaan desain intensif. Singkat tapi efektif untuk mencegah kelelahan.',

  // 3-minute timer users
  'user.teaLoverEmily': 'Emily Tea',
  'user.yogatrainerJohn': 'John Yoga',
  'user.busyMomLisa': 'Lisa Mom',
  'reviews.teaLoverEmily': 'Waktu sempurna untuk teh hijau saya! 3 menit memberikan rasa yang sempurna tanpa kepahitan. Suka peringatan suaranya!',
  'reviews.yogatrainerJohn': 'Saya menggunakan ini untuk latihan pernapasan cepat dengan klien. 3 menit pas untuk sesi yang menenangkan.',
  'reviews.busyMomLisa': 'Bagus untuk mengatur waktu anak-anak menyikat gigi. Mereka benar-benar menikmati hitung mundurnya sekarang!',

  // 5-minute timer users
  'user.meditatorZen': 'Zen Master',
  'user.chefTony': 'Chef Tony',
  'user.runnerMia': 'Mia Runner',
  'reviews.meditatorZen': 'Sempurna untuk meditasi pemula. 5 menit dapat dikelola namun efektif untuk latihan kesadaran.',
  'reviews.chefTony': 'Penting di dapur saya! Waktu sempurna untuk telur rebus setiap saat. Profesional dan dapat diandalkan.',
  'reviews.runnerMia': 'Saya menggunakan ini untuk peregangan pasca-lari. 5 menit memastikan saya tidak melewatkan rutinitas pemulihan saya!',

  // 10-minute timer users
  'user.studentDavid': 'David Student',
  'user.managerRachel': 'Rachel Manager',
  'user.writerJames': 'James Writer',
  'reviews.studentDavid': 'Bagus untuk istirahat belajar! 10 menit sempurna untuk reset mental tanpa kehilangan momentum.',
  'reviews.managerRachel': 'Saya menggunakan ini untuk sesi membaca fokus. 10 menit membaca tanpa gangguan benar-benar bertambah!',
  'reviews.writerJames': 'Sempurna untuk sprint menulis berwaktu. Tekanan 10 menit membantu saya mengatasi writer\'s block.',

  // 15-minute timer users
  'user.consultantAmy': 'Amy Consultant',
  'user.teacherBen': 'Ben Teacher',
  'user.freelancerSophie': 'Sophie Freelancer',
  'reviews.consultantAmy': 'Ideal untuk panggilan klien cepat dan rapat singkat. Membuat diskusi tetap fokus dan produktif.',
  'reviews.teacherBen': 'Saya menggunakan ini untuk aktivitas kelas dan kerja kelompok. Siswa tetap terlibat dengan batas waktu.',
  'reviews.freelancerSophie': 'Sesi Pomodoro sempurna! 15 menit kerja fokus diikuti dengan istirahat membuat saya produktif sepanjang hari.',

  // 30-minute timer users
  'user.executiveRobert': 'Robert Executive',
  'user.fitnessCoachMaya': 'Maya Fitness',
  'user.artistOlivia': 'Olivia Artist',
  'reviews.executiveRobert': 'Sangat baik untuk sesi kerja mendalam. 30 menit memungkinkan kemajuan yang berarti tanpa komitmen yang berlebihan.',
  'reviews.fitnessCoachMaya': 'Sempurna untuk sirkuit latihan lengkap. Klien saya menyukai waktu terstruktur untuk latihan yang berbeda.',
  'reviews.artistOlivia': 'Bagus untuk sesi kreatif. 30 menit memberikan waktu yang cukup untuk masuk ke flow state dan menciptakan sesuatu yang berarti.',
};
